import React from 'react'
import cn from 'classnames'
import { generateMarginClasses } from "@utils/spacing"

export const Card = React.forwardRef(({
  children,
  section,
  // Props to build the className
  small,
  cueCard,
  darkBorder,
  noShadow,
  noBorder,
  className,
  warning,
  isNew,
  highlighted,
  margin,
  ...rest
}, ref) => {
  const cardClassName = buildClassNamesFromProps({
    className, small, darkBorder, noShadow, noBorder, warning, highlighted, isNew, cueCard, margin
  })
  const cardProps = { ...rest, ...{ className: cardClassName }, ref }

  if (section) {
    return <section {...cardProps}>{children}</section>
  } else {
    return <div {...cardProps}>{children}</div>
  }
})

export const CardHeading = ({ children, className }) =>
  <div className={`ui-card__heading ${className || ''}`}>
    {children}
  </div>

export const CardContent = ({ children, className }) =>
  <div className={`ui-card__content ${className || ''}`}>
    {children}
  </div>

export const CardFooter = ({ children, className }) =>
  <div className={`ui-card__footer ${className || ''}`}>
    {children}
  </div>

const buildClassNamesFromProps = ({
  small,
  cueCard,
  darkBorder,
  noShadow,
  noBorder,
  className,
  warning,
  isNew,
  highlighted,
  margin
}) => {
  const base = 'ui-card'

  // Deprecated
  const marginClasses = generateMarginClasses(margin)
  const additionalClasses = className || ''

  return cn(base, additionalClasses, marginClasses, {
    [`${base}--small`]: small,
    [`${base}--cue-card`]: cueCard,
    [`${base}--dark-border`]: darkBorder,
    [`${base}--no-shadow`]: noShadow,
    [`${base}--no-border`]: noBorder,
    [`${base}--warning`]: warning,
    [`${base}--is-new`]: isNew,
    [`${base}--highlighted`]: highlighted,
  })
}
